<mat-sidenav-container>
	<mat-sidenav mode="side" [opened]="sidenavOpened()">
		<div class="sidenav-title">ZaidSystems</div>
		<nav class="sidenav-links">
    @if (authService.userSignal()?.preferences?.permisions?.includes('flota')) {
        <a [routerLink]="['/vessels']" class="sidenav-link">
            <mat-icon>directions_boat</mat-icon>
            <span class="sidenav-link-label">{{'home.vessels' | translator}}</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('motores')) {
        <a [routerLink]="['/engines']" class="sidenav-link">
            <mat-icon class="material-symbols-outlined">oven_gen</mat-icon>
            <span class="sidenav-link-label">{{'home.engines' | translator}}</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('equipos')) {
        <a [routerLink]="['/equipos']" class="sidenav-link">
            <mat-icon>account_tree</mat-icon>
            <span class="sidenav-link-label">{{'home.equipment' | translator}}</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('mantenimientos')) {
        <a [routerLink]="['/maintenances']" class="sidenav-link">
            <mat-icon>build</mat-icon>
            <span class="sidenav-link-label">{{'home.maintenance' | translator}}</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('manuales')) {
        <a [routerLink]="['/manuals']" class="sidenav-link">
            <mat-icon>menu_book</mat-icon>
            <span class="sidenav-link-label">{{'home.manuals' | translator}}</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('documentos')) {
        <a [routerLink]="['/part-lists']" class="sidenav-link">
            <mat-icon class="material-symbols-outlined">docs</mat-icon>
            <span class="sidenav-link-label">{{'home.documents' | translator}}</span>
        </a>
    }
	@if (authService.userSignal()?.preferences?.permisions?.includes('empresas')) {
		<a [routerLink]="['/companies']" class="sidenav-link">
			<mat-icon>business</mat-icon>
			<span class="sidenav-link-label">{{'home.companies' | translator}}</span>
		</a>
	}
    @if (authService.userSignal()?.preferences?.permisions?.includes('leo')) {
        <a [routerLink]="['/chatbot']" class="sidenav-link">
            <mat-icon>auto_awesome</mat-icon>
            <span class="sidenav-link-label">LEO</span>
        </a>
    }

    @if (authService.userSignal()?.preferences?.permisions?.includes('ayuda')) {
        <a [routerLink]="['/help']" class="sidenav-link">
            <mat-icon>help</mat-icon>
            <span class="sidenav-link-label">{{'home.help' | translator}}</span>
        </a>
    }

    <a [routerLink]="['/profile']" class="sidenav-link">
        <mat-icon>person</mat-icon>
        <span class="sidenav-link-label">{{'home.profile' | translator}}</span>
    </a>
</nav>
    <div class="sidenav-footer">
        <div class="sidenav-lang-selector">
            <div class="lang-label">
                <mat-icon>language</mat-icon>
            </div>
            <div class="lang-buttons">
                <button mat-button role="button"
                        [class.active]="langService.currentLang() === 'es'"
                        (click)="langService.load('es')">
                    ES
                </button>
                <span class="separator">|</span>
                <button mat-button role="button"
                        [class.active]="langService.currentLang() === 'en'"
                        (click)="langService.load('en')">
                    EN
                </button>
            </div>
        </div>
        <div class="sidenav-logout">
            <button mat-stroked-button class="logout-btn" role="button" (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>{{'home.logout' | translator}}</span>
            </button>
        </div>
    </div>
	</mat-sidenav>
	<mat-sidenav-content>
		<mat-toolbar color="primary">
			<button mat-icon-button (click)="toggleSidenav()" aria-label="Abrir menú">
				@if (sidenavOpened()) {
				<mat-icon>menu_open</mat-icon>
				}@else {
				<mat-icon>menu</mat-icon>
				}
			</button>
			<div class="principal-header">
				<app-principal-header></app-principal-header>
			</div>
		</mat-toolbar>
		<div class="content-container">
			@if(loading$ | async){
			<div class="global-spinner">
				<mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
				</mat-progress-spinner>
			</div>

			}
			<router-outlet></router-outlet>
			<app-chatbot-toggle></app-chatbot-toggle>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>